import React, { useEffect, useState } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import InsertTori from "./components/InsertTori/InsertTori";
import { useDispatch, useSelector } from "react-redux";
import { read } from "Helpers/LocalStorage";
import { GetAllTori } from "Stores/actions";
import ToriTable from "./ToriTable/ToriTable";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Translator from "Languages/Utility/Translator";

function Tori() {
  const { toriDataPagination } = useSelector((state) => ({
    toriDataPagination: state.tori.toriDataPagination,
  }));
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Limit: toriDataPagination.Limit,
          Page: toriDataPagination.Page,
          Name: "",
        };
        await dispatch(GetAllTori(params));
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, []);
  
  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-2">
        <PageTitle title={<Translator id={"net"}/>} />
        <div className="top-buttons">
          {(read("toriRules").accessRegister !== false) &&  <InsertTori />}
        </div>
      </div>
      <MuiPaper className="mb-5">
        <ToriTable />
      </MuiPaper>
    </>
  );
}

export default Tori;
